import Button from "components/general/buttonv2";
import Head from "next/head";
import { useState } from "react";
import styled from "styled-components";

const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
const StyledContainer = styled.div`
  max-width: 1280px;
  width: calc(100% - 4rem);
  padding: 4rem 0;
  gap: 3rem;
  @media screen and (max-width: 1280px) {
    flex-direction: column;
  }
  a {
    color: #5885f8;
  }
  h2 {
    font-size: 2rem;
    line-height: 1.3;
    margin-bottom: 2rem;
  }
  h3 {
    font-size: 1.5rem;
    line-height: 1.3;
  }
  h4 {
    font-size: 1.3rem;
    line-height: 1.3;
  }
`;
const StyledQuestion = styled.div`
  border-radius: 1rem;
  color: var(--text-color);
  padding: 1rem 2rem;
  font-weight: 700;
  cursor: pointer;
  gap: 1rem;
  display: flex;
  svg {
    height: auto;
    width: 1rem;
    fill: var(--text-color);
  }
`;
const StyledAnswer = styled.div`
  border-radius: 1rem;
  padding: 1rem 2rem;
`;
const StyledItem = styled.li`
  width: 100%;
  flex-direction: column;
  display: flex;
  border-radius: 6px;
  margin-bottom: 1rem;
  background: var(--raised-background-color);
`;

const MinusSvg = () => (
  <svg
    clipRule="evenodd"
    fillRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit="2"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m21 11.75c0-.414-.336-.75-.75-.75h-16.5c-.414 0-.75.336-.75.75s.336.75.75.75h16.5c.414 0 .75-.336.75-.75z"
      fillRule="nonzero"
    />
  </svg>
);

const PlusSvg = () => (
  <svg
    clipRule="evenodd"
    fillRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit="2"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m11 11h-7.25c-.414 0-.75.336-.75.75s.336.75.75.75h7.25v7.25c0 .414.336.75.75.75s.75-.336.75-.75v-7.25h7.25c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-7.25v-7.25c0-.414-.336-.75-.75-.75s-.75.336-.75.75z"
      fillRule="nonzero"
    />
  </svg>
);

const FaqItem = ({ question, answer, video, image }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <StyledItem>
      <StyledQuestion onClick={() => setExpanded((prev) => !prev)}>
        {expanded ? <MinusSvg /> : <PlusSvg />}
        <div>{question}</div>
      </StyledQuestion>
      {expanded && (
        <StyledAnswer>
          <p dangerouslySetInnerHTML={{ __html: answer }}></p>

          {video && (
            <Button style={{ marginTop: "1rem" }} href={video} buttonBuddy={true}>
              Watch Video
            </Button>
          )}

          {image && (
            <div style={{ marginTop: "10px" }}>
              {/* eslint-disable-next-line @next/next/no-img-element*/}
              <img src={image} alt={`Image for ${question}`} style={{ maxWidth: "100%" }} />
            </div>
          )}
        </StyledAnswer>
      )}
    </StyledItem>
  );
};

const FAQComponent = ({ faqData }) => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqData.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };
  return (
    <>
      <Head>
        {/* Add JSON-LD to the head of the page */}
        {faqData && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
          />
        )}
      </Head>
      <StyledWrapper>
        <StyledContainer>
          <h2>Frequently asked questions</h2>
          <ul style={{ padding: 0 }}>
            {faqData.map((faq, index) => (
              <FaqItem
                key={index}
                question={faq.question}
                answer={faq.answer}
                video={faq.video}
                image={faq.image}
              />
            ))}
          </ul>
        </StyledContainer>
      </StyledWrapper>
    </>
  );
};

export default FAQComponent;
